import endpoints from '@config/endpoints';
import { dateFormate, facilityDetails } from '@constants/index';
import ServiceOutline from '@pages/Beneficiary-block/WomenComponent/ANC/CommonOutline/AddServiceOutline';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { getData, getDataWithCache } from '@services/CommonApiService';
import { setAncPregBackHandler, setANCVisitDate, updateAncService, updatePNC } from '@store/actions/beneficiaryAction';
import { RootState } from '@store/reducers';
import dayjs from 'dayjs';
import config from '@config/config';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import AlertPopup from '../CreateNewChild/AlertPopup';
import './index.css';
import { getOngoingPNCDetails, PNC_COMMON_CONSTANTS, PNC_ERROR_MESSAGES, PNC_FIELDS_NAME, PNC_NAVIGATION, visitFormData } from './PNCConstants';
import { addDaysToDate, areDatesSame, formateDateToTimeStamp, getHBYCPeriodDetails, getVisitDateThroughVHND, isMobilizerHavingValue, subtractDaysFromDate } from '@utils/commonUtils';
import { getDeliveryOutcome, recentVisitDatesApi } from './PNCServices';
import { errorLogger } from '@utils/applicationLogUtils';
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import { CHILD_NAVIGATION, getOngoingHBYCDetails } from '../Child/ChildtrackingConstant';
import { NAVIGATION_ABORTION } from '../Abortion/AbortionConstants';
import { getLatestServiceAvailedDate } from '@services/ancApiServices';
import { getLatestServiceAvailedDateByBenefId } from '@services/beneficiaryApiServices';
import Spinner from '@components/common/Spinner';
import { DELIVERY_COMMON_CONSTANTS, getPNCDetails } from '../DeliveryOutcome/constants/DeliveryConstants';
import FormatDate from '@utils/dateFormat';
interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  id?: any;
  code?: any;
  ufTaggedId?: any;
}

export interface formStateType {
  [key: string]: objectType;
}

const PNCFacilityDetails = ({childService}: any) => {
  const facilityObj: any = {
    facilityType: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined,
    },
    facilityName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined,
    },
    hprName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      ufTaggedId: '',
    },
    ashaName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  };
  const breadcrumbItemName = [{ value: 'beneficiary', label: PNC_COMMON_CONSTANTS.FACILITY_DETAILS },];
  const userId = localStorage.getItem('userId');
  const { state } = useLocation();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [serviceDetails, setServiceDetails] = useState(state);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [ufId, setUfId] = useState<string>('');
  const [navItemsModal, setnavItemsModal] = useState([PNC_COMMON_CONSTANTS.FACILITY_DETAILS]);
  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const [facilityFormState, setFacilityFormState] = useState<formStateType>(facilityObj);
  const [facilityData, setFacilityData] = useState<any>(facilityDetails);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [visitForm, setVisitForm] = useState<formStateType>({
    dateOfDelivery: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    dateOfDischarge: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    timeOfDischarge: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    dateOfVisit: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
    },
    visitNumber: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
    },
  });
  const [vistFormData, setVisitFormData] = useState<any>(visitFormData);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [facilityDetailsRes, setFacilityDetailsRes] = useState<any>();
  const [currDeliveryDate, setCurrDeliveryDate] = useState<any>();
  const [visitedDates, setVisitedDates] = useState<any[]>([]);
  const [healthProviderOptions, setHealthProviderOptions] = useState<any[]>([]);
  const [latestServiceDate, setLatestServiceDate] = useState<any>();

  const facilityDetail = useSelector((state: RootState) => state.beneficiary.facilityDetails);
  const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails,);
  const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails,);
  const currServiceSubCtgryId = useSelector((state: RootState) => state.beneficiary.currServiceSubCtgryId,);
  const isPNCFirstVisit = useSelector((state: RootState) => state.beneficiary.isPNCFirstVisit);
  const hasKeysOnFacility = currentFacilityDetails ? Object.keys(currentFacilityDetails).length > 0 : false;
  const pregnancyId = useSelector((state: RootState) => state.beneficiary.currPregnancyId);
  const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
  const currentChildServiceId = useSelector((state: RootState) => state.beneficiary.currentChildServiceId);
  const pregHistoryDetails = useSelector((state: RootState) => state.beneficiary.pregHistoryDetails);
  const isPregClosure = (pregHistoryDetails?.module_code === PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY || pregHistoryDetails?.module_code === PNC_COMMON_CONSTANTS.ABORTION_DETAILS || pregHistoryDetails?.module_code === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY);
  const isDeliveryCaptured = isPregClosure ? pregHistoryDetails?.pregnancy_closure_date : pregHistoryDetails?.delivery_date;
  const eventExution = useSelector((state: RootState) => state.eventExution);
  const visitDateThrouhVHND : any = getVisitDateThroughVHND(eventExution);
  const navigateWithMenuItem = useNavigateWithMenuItem();
 const [deliveryOutcome,setDeliveryOutcome] = useState<any>();
 const [latestChildAvailedServiceDateRes,setLatestChildAvailedServiceDateRes] = useState<any>();

  const navs = 100 / navItemsModal.length;

  useEffect(() => {
    initialFetch();
  }, []);

    const fetchLatestServiceAvailedDate = async (pregnancyId: any) => {
      return await getLatestServiceAvailedDate(pregnancyId);
    }

  useEffect(() => {
    if(isPNCFirstVisit && !childService && !isDeliveryCaptured && !isPregClosure) {
      setVisitFormData((prevState:any) => ({
        ...prevState,
        dateOfDelivery: {
          '#type': 'date',
          '#title': 'Date of Delivery',
          '#webform_key': 'dateOfDelivery',
          "#isDisabled":false,
          '#required': true,
          '#minDate': subtractDaysFromDate(dayjs(), 90, 'day'),
          '#maxDate': new Date()
        },
      }))
    }
  },[isPNCFirstVisit]);

  const initialFetch = async () => {
    try {
      setIsLoading(true);
      const latestServiceAvailedDate = await fetchLatestServiceAvailedDate(pregnancyId);
      const latestAvailedServiceDate = latestServiceAvailedDate?.data?.[0]?.get_latest_service_availed_date;
      setLatestServiceDate(latestAvailedServiceDate);
      if(serviceDetails?.currRoute !== CHILD_NAVIGATION.NEW_BORN && serviceDetails?.currRoute !== NAVIGATION_ABORTION.ABORTION_FORM && serviceDetails?.currRoute !== CHILD_NAVIGATION.SICK_CHILD_CARE) {
        handleVisitNumber();
      }
      if (hasKeysOnFacility) {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          facilityName: {
            ...prevState.facilityName,
            value: currentFacilityDetails?.facilityName,
            id: currentFacilityDetails?.facilityId,
          },
          facilityType: {
            ...prevState.facilityType,
            value: currentFacilityDetails?.facilityType,
          },
          hprName: {
            ...prevState.hprName,
            value: currentFacilityDetails?.hprName,
            id: currentFacilityDetails?.healthProviderId,
          },
          ashaName: {
            ...prevState.ashaName,
            value: currentFacilityDetails?.ashaName,
            id: currentFacilityDetails?.mobilizerId,
          },
        }));
        setVisitForm((prevState:any) => ({
            ...prevState,
            dateOfDelivery: {
                ...prevState.dateOfDelivery,
                value: currentFacilityDetails?.deliveryDate,
            },
            dateOfVisit: {
                ...prevState.dateOfVisit,
                value: visitDateThrouhVHND ? visitDateThrouhVHND : currentFacilityDetails?.visitDate ? currentFacilityDetails?.visitDate : '',
            },
            visitNumber: {
              ...prevState.visitNumber,
              value: currentFacilityDetails?.visitNumber,
            },
            dateOfDischarge: {
              ...prevState.dateOfDischarge,
              value: currentFacilityDetails?.dateOfDischarge,
            },
            timeOfDischarge: {
              ...prevState.timeOfDischarge,
              value: currentFacilityDetails?.timeOfDischarge,
            },
        }))
        setVisitFormData((prevState:any) => ({
          ...prevState,
          dateOfVisit: {
              ...prevState.dateOfVisit,
              '#minDate': currentFacilityDetails?.deliveryDate? currentFacilityDetails?.deliveryDate : dayjs().subtract(config.serviceDateLimit, 'day'),
          }}))
      }
      let latestChildAvailedServiceDateRes;
      if(childService) {
        latestChildAvailedServiceDateRes = await getLatestServiceAvailedDateByBenefId(childDetails?.benef_id);
        setLatestChildAvailedServiceDateRes(latestChildAvailedServiceDateRes)
      }

      const facilityDetailsRespone = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`,);
      setFacilityDetailsRes(facilityDetailsRespone?.data[0]);
      const parentFacility = facilityDetailsRespone.data[0]?.find((item: any) => item.is_parent === true,);
      const facilityTypeOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
          value: key.facility_type_name,
          label: key.facility_type_name,
          id: key.facility_type_id,
          code: key.facility_type_code,
        }),
      );

      const facilityNameOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
          value: key.facility_name,
          label: key.facility_name,
          id: key.facility_id,
          code: key.facility_code,
        }),
      );
      !hasKeysOnFacility &&
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          facilityName: {
            ...prevState.facilityName,
            value: parentFacility?.facility_name,
            id: parentFacility?.facility_id,
          },
          facilityType: {
            ...prevState.facilityType,
            value: parentFacility?.facility_type_name,
            id: parentFacility?.facility_type_id,
          },
        }));
      setFacilityData((prevState: any) => {
        return {
          ...prevState,
          facilityType: {
            ...prevState.facilityType,
            '#options': facilityTypeOptions,
          },
          facilityName: {
            ...prevState.facilityName,
            '#options': facilityNameOptions,
          },
        };
      });
      const facilityName = getFacilityDetailFromParentById(facilityDetail?.facilityId,facilityDetailsRespone?.data[0],);
      const facilityTypeName = getFacilityDetailFromParentById(facilityDetail?.facilityId,facilityDetailsRespone?.data[0],);
      fetchHprName(parentFacility?.facility_id, facilityName, facilityTypeName);
      let deliveryOutcomeResponse:any;
      if(!isPNCFirstVisit && !childService){
        deliveryOutcomeResponse = await getDeliveryOutcome(pregnancyId);
        setDeliveryOutcome(deliveryOutcomeResponse?.data?.[0])
      }
      const existingDischargeDate = deliveryOutcomeResponse?.data[0]?.date_of_discharge || currentFacilityDetails?.dateOfDischarge;

      if(deliveryOutcomeResponse?.data[0]?.place_of_delivery_code !== "home" && !existingDischargeDate && currentFacilityDetails?.visitNumber !== 1 && !childService && !isPregClosure && !isPNCFirstVisit){
        setVisitFormData((prevState:any) => ({
          ...prevState,
          dateOfDischarge: {
            '#type': 'date',
            '#title': 'Date of Discharge from Health Facility After Delivery',
            '#webform_key': 'dateOfDischarge',
            '#required': true,
            '#isDisabled':isPNCFirstVisit ? currentFacilityDetails?.deliveryDate ? false:true:false,
            '#minDate': currentFacilityDetails?.deliveryDate ? currentFacilityDetails?.deliveryDate : deliveryOutcomeResponse?.data[0]?.date_of_delivery? dayjs(deliveryOutcomeResponse?.data[0]?.date_of_delivery) : subtractDaysFromDate(dayjs(), 45, 'day'),
            '#maxDate': new Date()
          },
          timeOfDischarge: {
            '#type': 'time',
            '#title': 'Time of Discharge from Health Facility After Delivery',
            '#webform_key': 'timeOfDischarge',
            '#required': true,
            '#isDisabled':isPNCFirstVisit ? currentFacilityDetails?.deliveryDate ? false:true:false,
          },
        }))
        handleDateOfDischargeValidation(deliveryOutcomeResponse?.data[0]?.date_of_delivery);
      } else if (deliveryOutcomeResponse?.data[0]?.place_of_delivery_code !== "home" && existingDischargeDate && !childService && !isPregClosure && !isPNCFirstVisit && currentFacilityDetails?.visitNumber !== 1) {
        // Already captured — prefill and disable
        setVisitFormData((prevState:any) => ({
          ...prevState,
          dateOfDischarge: {
            '#type': 'date',
            '#title': 'Date of Discharge from Health Facility After Delivery',
            '#webform_key': 'dateOfDischarge',
            '#required': false,
            '#isDisabled': true,
          },
          timeOfDischarge: {
            '#type': 'time',
            '#title': 'Time of Discharge from Health Facility After Delivery',
            '#webform_key': 'timeOfDischarge',
            '#required': false,
            '#isDisabled': true,
          },
        }))
        setVisitForm((prevState:any) => ({
          ...prevState,
          dateOfDischarge: {
            ...prevState.dateOfDischarge,
            value: existingDischargeDate,
          },
          timeOfDischarge: {
            ...prevState.timeOfDischarge,
            value: deliveryOutcomeResponse?.data[0]?.date_of_discharge || currentFacilityDetails?.timeOfDischarge,
          },
        }))
      }
      handleVisitDateValidation(latestAvailedServiceDate, latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef,deliveryOutcomeResponse?.data[0]);
    } catch (error: any) {
      errorLogger(error?.response?.data||error?.response||error);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {

    const dob = dayjs(childDetails.dob);
    const currentDate = dayjs();
    let serviceEndDate: any;
    let servicePeriodName = '';
    let isFieldDisabled = false;
    let disabledMessage = '';
    let skipLatestServiceDateCheck = false;

    switch (serviceDetails?.currRoute) {
      case CHILD_NAVIGATION.NEW_BORN:
        {
          serviceEndDate = dob.add(44, 'day');
          const pncDetailss = getPNCDetails(childDetails.dob);
          servicePeriodName = 'New Born';
          break;
        }
      case PNC_NAVIGATION.PNC_MOTHER:
        {
          const pncDetails = getPNCDetails(currDeliveryDate);
          if (pncDetails && pncDetails.length > 0) {
            const lastPncPeriod = pncDetails[pncDetails.length - 1];
            serviceEndDate = dayjs(lastPncPeriod.endDate);
            servicePeriodName = 'PNC Mother';
          }
          break;
        }

      case CHILD_NAVIGATION.SICK_CHILD_CARE:
        {
          serviceEndDate = dob.add(2, 'year');
          servicePeriodName = 'Sick Child Care';
          break;
        }

      case CHILD_NAVIGATION.HBYC_FORM:
        {
          const hbycPeriodDetails = getHBYCPeriodDetails(childDetails.dob);
          if (hbycPeriodDetails && hbycPeriodDetails.length > 0) {
            const lastHbycPeriod = hbycPeriodDetails[hbycPeriodDetails.length - 1];
            serviceEndDate = dayjs(lastHbycPeriod.endDate);
            servicePeriodName = 'HBYC';
          }
          break;
        }

      default:
        {
          const pncDetails = getPNCDetails(childDetails.dob);
          if (pncDetails && pncDetails.length > 0) {
            const lastPncPeriod = pncDetails[pncDetails.length - 1];
            serviceEndDate = dayjs(lastPncPeriod.endDate);
            servicePeriodName = 'HBNC';
          }
          skipLatestServiceDateCheck = true;
          break;
        }
    }

    if (serviceEndDate) {
      const daysSinceServiceEnd = currentDate.diff(serviceEndDate, 'day');
      let maxDate = FormatDate(currentDate);
      let maxDateKey = 'currentDate';
      
      if (daysSinceServiceEnd >= 0 && daysSinceServiceEnd < 90) {
        maxDate = FormatDate(serviceEndDate);
        maxDateKey = 'serviceEndDate';

        if (!skipLatestServiceDateCheck &&
            latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef && 
            dayjs(latestChildAvailedServiceDateRes.data[0].get_latest_service_availed_date_for_benef).isAfter(serviceEndDate, 'day')) {
          isFieldDisabled = true;
          disabledMessage = `Visit date cannot be in future for ${servicePeriodName} service period`;
        }
      } else if (daysSinceServiceEnd >= 90) {
        isFieldDisabled = true;
        disabledMessage = `${servicePeriodName} service period has ended more than 90 days ago. Visit date cannot be captured.`;
      }

      setVisitFormData((prevState: any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          '#maxDate': maxDate,
          '#isDisabled': isFieldDisabled,
        }
      }));

      setVisitForm((prevState: any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          isError: isFieldDisabled,
          message: disabledMessage,
        }
      }));
    }
  }, [childService, childDetails?.dob, serviceDetails?.currRoute, latestChildAvailedServiceDateRes, currDeliveryDate]);

  const handleVisitNumber = () => {
    setVisitFormData((prevState:any) => ({
      ...prevState,
      visitNumber: {
        '#type': 'textfield',
        '#title': !childService ?'PNC Period':'Visit Number',
        '#webform_key': 'visitNumber',
        "#isDisabled":true,
        '#required': true,
      },
    }))
  }

  const handleVisitDateValidation = async (latestServiceAvailedDate: any, latestChildAvailedServiceDate: any,deliveryOutcomeResponse?:any) => {
    let deliveryDate:any;
    let minDate: any;
    let dateOfDischarge:any;
    if(!childService){
      if(isPNCFirstVisit) {
        deliveryDate = visitForm?.dateOfDelivery?.value;
        dateOfDischarge = visitForm?.dateOfDischarge?.value;
        minDate = getMinDate(deliveryDate, '', false);
      } else {
        const resolvedDeliveryOutcome = deliveryOutcomeResponse ?? deliveryOutcome;
        deliveryDate = resolvedDeliveryOutcome?.date_of_delivery;
        dateOfDischarge = resolvedDeliveryOutcome?.date_of_discharge;
        const placeOfDelivery = resolvedDeliveryOutcome?.place_of_delivery_code;
        minDate = getMinDate(deliveryDate, placeOfDelivery, false);
      }
      if(isDeliveryCaptured) {
        deliveryDate = isDeliveryCaptured;
        minDate = getMinDate(isDeliveryCaptured, '', false);
      }
      setVisitFormData((prevData: any) => ({
        ...prevData,
        dateOfVisit: {
          ...prevData.dateOfVisit,
          '#minDate': latestServiceAvailedDate
            ? dayjs(latestServiceAvailedDate).isBefore(deliveryDate) ||
            (dateOfDischarge && dayjs(latestServiceAvailedDate).isBefore(dateOfDischarge))
              ? dateOfDischarge
                ? getMinDate(dateOfDischarge, '', false)
                : getMinDate(deliveryDate, '', false)
              : getMinDate(latestServiceAvailedDate, '', false)
            : isPregClosure
              ? getMinDate(pregHistoryDetails?.pregnancy_closure_date, '', false)
              : visitDateThrouhVHND
                ? visitDateThrouhVHND
                : serviceDetails?.dateOfDischarge
                  ? handleDeliveryVisitDateValidation(
                      serviceDetails?.dateOfDischarge,
                    )
                  : minDate,
        },
      }));
    } else {
      minDate = getMinDate(childDetails?.dob, childDetails?.place_of_delivery_code, true);
      let isHBYCVisit = false;
      if(serviceDetails?.currRoute === CHILD_NAVIGATION.HBYC_FORM) {
        const hbycPeriodDetails = getHBYCPeriodDetails(childDetails?.dob);
        minDate = getMinDate(childDetails?.dob, '', true, true, hbycPeriodDetails[0].startDate);
        isHBYCVisit = true;
      }
      deliveryDate = childDetails?.dob;
      
      let finalMinDate;
      const isHBNCVisit = serviceDetails?.currRoute !== CHILD_NAVIGATION.HBYC_FORM && 
                           serviceDetails?.currRoute !== CHILD_NAVIGATION.NEW_BORN && 
                           serviceDetails?.currRoute !== CHILD_NAVIGATION.SICK_CHILD_CARE;
      if (latestChildAvailedServiceDate) {
        if (isHBNCVisit) {
          const pncDetails = getPNCDetails(childDetails?.dob);
          const hbncServiceEndDate = pncDetails?.length > 0 ? dayjs(pncDetails[pncDetails.length - 1].endDate) : null;
          if (hbncServiceEndDate && dayjs(latestChildAvailedServiceDate).isAfter(hbncServiceEndDate, 'day')) {
            finalMinDate = minDate;
          } else {
            finalMinDate = getMinDate(latestChildAvailedServiceDate, '', false, isHBYCVisit, minDate);
          }
        } else {
          finalMinDate = getMinDate(latestChildAvailedServiceDate, '', false, isHBYCVisit, minDate);
        }
      } else if (visitDateThrouhVHND) {
        finalMinDate = visitDateThrouhVHND;
      } else {
        finalMinDate = minDate;
      }

      setVisitFormData((prevData: any) => ({
        ...prevData,
        dateOfVisit : {
          ...prevData.dateOfVisit,
          '#minDate': finalMinDate,
        }
      }));
    }
    setCurrDeliveryDate(deliveryDate);
    if(deliveryDate){
      getPNCAndSetVisitNumber(deliveryDate, dayjs(),deliveryOutcomeResponse);
    }
  }
 
  const getMinDate = (deliveryDate:any, placeOfDeliveryCode:string, isChild:boolean, isHBYC?:boolean, hbycStartDate?:any) => {
    if(serviceDetails?.currRoute === CHILD_NAVIGATION.HBYC_FORM) {
      if(deliveryDate && dayjs().diff(dayjs(deliveryDate), 'day') < 90) {
        if(hbycStartDate && dayjs(deliveryDate).isBefore(dayjs(hbycStartDate), 'day')) {
          return dayjs(hbycStartDate);
        }
        return dayjs(deliveryDate);
      } else {
        if(hbycStartDate && dayjs().diff(dayjs(hbycStartDate), 'day') < 90) {
          return dayjs(hbycStartDate);
        } else {
          return subtractDaysFromDate(dayjs(), 90, 'day');
        }      
      }
    } else if((placeOfDeliveryCode === PNC_COMMON_CONSTANTS.TRANSIT || placeOfDeliveryCode === PNC_COMMON_CONSTANTS.INSTITUTIONAL) && isChild && serviceDetails?.currRoute !== CHILD_NAVIGATION.NEW_BORN) {
      if(dayjs().diff(dayjs(deliveryDate), 'day') < 90) {
        return deliveryDate ? addDaysToDate(deliveryDate, 89, 'day') : subtractDaysFromDate(dayjs(), 90, 'day')
      } else {
        return subtractDaysFromDate(dayjs(), 90, 'day')
      }
    } else if((placeOfDeliveryCode === PNC_COMMON_CONSTANTS.TRANSIT || placeOfDeliveryCode === PNC_COMMON_CONSTANTS.INSTITUTIONAL) && serviceDetails?.currRoute !== CHILD_NAVIGATION.NEW_BORN) {
      return deliveryDate ? dayjs().diff(dayjs(deliveryDate), 'day') < 90 ? addDaysToDate(deliveryDate, 89, 'day') : subtractDaysFromDate(dayjs(), 90, 'day') : subtractDaysFromDate(dayjs(), 90, 'day');
    } else {
      return deliveryDate ? dayjs().diff(dayjs(deliveryDate), 'day') < 90 ? dayjs(deliveryDate) : subtractDaysFromDate(dayjs(), 90, 'day') : subtractDaysFromDate(dayjs(), 90, 'day');
    }
  }

  const fetchHprName = async (id: any, facilityName?: any, facilityTypeName?: any,) => {
    try {
      const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(id)}`,);
      const healthProviderOptionsData = Health_provider?.data?.map((key: any) => ({
        value: `${key?.f_name} ${key?.l_name}`,
        label: `${key?.f_name} ${key?.l_name}`,
        id: key?.user_id,
        code: key?.user_code,
        ufTaggedId: key?.uf_tagged_id,
      }));
      setHealthProviderOptions(healthProviderOptionsData);
      const userDetail = await getData<any>( `${endpoints.getUserById}/${userId}`,);
      const currUserName =
        userDetail.data[0].first_name +
        ' ' +
        userDetail.data[0].middle_name +
        ' ' +
        userDetail.data[0].last_name;

      const healthProviderData = Health_provider?.data.find((item: any) =>`${item.f_name} ${item.l_name}` ===
          currUserName.replace('null', '').replace('  ', ' '),
      );

      if (!hasKeysOnFacility) {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          hprName: {
            ...prevState.hprName,
            value: healthProviderData ? `${healthProviderData?.f_name ?? ''} ${healthProviderData?.l_name ?? ''}`.trim() : '',
            id: healthProviderData?.user_id ?? '',
            label: healthProviderData ? `${healthProviderData?.f_name ?? ''} ${healthProviderData?.l_name ?? ''}`.trim() : '',
            code: healthProviderData?.user_code,
            ufTaggedId: healthProviderData?.uf_tagged_id,
          },
        }));
      }

      setFacilityData((prevState: any) => {
        return {
          ...prevState,
          hprName: {
            ...prevState.hprName,
            '#options': healthProviderOptionsData,
          }
        };
      });

      if (healthProviderData?.uf_tagged_id) {
        const ashaNameRes = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`,);
        const ashanameOptions = ashaNameRes?.data.map((key: any) => ({
          value: key.f_name + ' ' + key.l_name,
          label: key.f_name + ' ' + key.l_name,
          id: key.mobiliser_id,
          code: key.user_code,
        }));
        setFacilityData((prevState: any) => {
          return {
            ...prevState,
            ashaName: {
              ...prevState.ashaName,
              '#options': ashanameOptions,
            },
          };
        });
      }

    } catch (error: any) {
      errorLogger(error?.response?.data||error?.response||error);
    }
  };

  useEffect(() => {
    const fetchData = async () =>{
      if(ufId && facilityFormState.hprName.value){
        const ashaNameRes = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`,);
        const ashanameOptions = ashaNameRes?.data.map((key: any) => ({
        value: key.f_name + ' ' + key.l_name,
        label: key.f_name + ' ' + key.l_name,
        id: key.mobiliser_id,
        code: key.user_code,
      }));
      setFacilityData((prevState: any) => {
        return {
          ...prevState,
          ashaName: {
            ...prevState.ashaName,
            '#options': ashanameOptions,
          },
        };
      });
      }
    }
    fetchData();
  }, [facilityFormState.hprName.value]);

  const getPNCAndSetVisitNumber = async (deliveryDate: any, visitDate: any,deliveryOutcomeResponse?:any) => { 
    let ongoingServiceVisitNumber;
    if(serviceDetails?.currRoute === CHILD_NAVIGATION.HBYC_FORM) {
      const ongoingHBYCDetail = getOngoingHBYCDetails(deliveryDate, visitDate);
      ongoingServiceVisitNumber = ongoingHBYCDetail?.[0]?.hbyc;
    } else {
      const onGoingPncDetails = getOngoingPNCDetails(deliveryDate, visitDate);
      ongoingServiceVisitNumber = onGoingPncDetails?.[0]?.pnc;
    }
    if(ongoingServiceVisitNumber === 1){
      if(isPNCFirstVisit){
       setVisitFormData((prevState:any)=>({
        dateOfVisit:{
         ...prevState.dateOfVisit
        },
        dateOfDelivery:{
          ...prevState.dateOfDelivery
        },
        visitNumber:{
          ...prevState.visitNumber
        }
      }))
    }else{
      setVisitFormData((prevState:any)=>({
        dateOfVisit:{
         ...prevState.dateOfVisit
        },
        visitNumber:{
          ...prevState.visitNumber
        }
      }))
    };
    setVisitForm((prevState:any)=>({
      ...prevState,
      dateOfDischarge:{
        ...prevState.dateOfDischarge,
        value:'',
        isError:false
      },
      timeOfDischarge:{
        ...prevState.timeOfDischarge,
        value:'',
        isError:false
      },
    }))
    }else if(deliveryOutcomeResponse?.place_of_delivery_name !== DELIVERY_COMMON_CONSTANTS.HOME && ongoingServiceVisitNumber !== 1 && !isPregClosure && !childService && !isPNCFirstVisit){
      const existingDischarge = deliveryOutcome?.date_of_discharge || deliveryOutcomeResponse?.date_of_discharge || currentFacilityDetails?.dateOfDischarge;
      if (!existingDischarge) {
        setVisitFormData((prevState:any) => ({
          ...prevState,
          dateOfDischarge: {
            '#type': 'date',
            '#title': 'Date of Discharge from Health Facility After Delivery',
            '#webform_key': 'dateOfDischarge',
            '#required': true,
            '#isDisabled': false,
            '#minDate': currentFacilityDetails?.deliveryDate ? currentFacilityDetails?.deliveryDate : deliveryDate ? deliveryDate : subtractDaysFromDate(dayjs(), 45, 'day'),
            '#maxDate': new Date()
          },
          timeOfDischarge: {
            '#type': 'time',
            '#title': 'Time of Discharge from Health Facility After Delivery',
            '#webform_key': 'timeOfDischarge',
            '#required': true,
            '#isDisabled': false
          },
        }))
      }
    }
      setVisitForm((prevState: any) => ({
        ...prevState,
        visitNumber: {
          ...prevState.visitNumber,
          value: ongoingServiceVisitNumber?ongoingServiceVisitNumber:'',
        },
      }));
  }


  const getFacilityDetailFromParentById = (id: any, dataList: any) => {
    return dataList?.find((item: any) => item.facility_id === id);
  };
  const handleFacilityFormChange = (value: any, key: string, id: any,code: any,option:any) => {
    if (key === 'facilityName' && !value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          value: '',
        },
        hprName: {
          ...prevState.hprName,
          value: '',
        },
      }));
    }
    else if (key === 'facilityType' && !value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: '',
        },
        hprName: {
          ...prevState.hprName,
          value: '',
        },
      }));
    }
    else if (value && key === 'hprName') {
    setFacilityFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    const selectedOption = healthProviderOptions.find((item: any) => item.id === id);
    setUfId(selectedOption.ufTaggedId)
  }
    else if (key === 'facilityName' && value) {
      const facilityDetail = facilityDetailsRes?.find(
        (item: any) => item.facility_name === value,
      );
      fetchHprName(facilityDetail.facility_id);
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          value: facilityDetail.facility_type_name,
          label: facilityDetail.facility_type_name,
          id: facilityDetail.facility_type_id,
          code: facilityDetail.facility_type_code,
        },
      }));
    }
    else if (key === 'facilityType' && value) {
      const facilityDetail = facilityDetailsRes?.find(
        (item: any) => item.facility_type_name === value,
      );
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: facilityDetail.facility_name,
          label: facilityDetail.facility_name,
          id: facilityDetail.facility_id,
          code: facilityDetail.facility_code,
        },
      }));
    }
    setFacilityFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };
  const getDateBasedOnValidation = (date: any, noOfDaysToAdd: number, unit: any,) => {
    return dayjs(date).add(noOfDaysToAdd, unit);
  };


  const handleDateOfDischargeValidation = (value:any) => {
    if(value) {
      const today = dayjs(new Date());
      const after42Days = getDateBasedOnValidation(value, 41, DELIVERY_COMMON_CONSTANTS.DAY);
      const minDate = dayjs(value);
      const maxDate = today.isAfter(after42Days) ? after42Days : today;
      if(deliveryOutcome?.place_of_delivery_name!==DELIVERY_COMMON_CONSTANTS.HOME && !childService && !isPNCFirstVisit){
        setVisitFormData((prevState: any) => ({
        ...prevState,
        dateOfDischarge: {
          '#type': 'date',
          '#title': 'Date of Discharge from Health Facility After Delivery',
          '#webform_key': 'dateOfDischarge',
          '#required': true,
          '#isDisabled': false,
          '#minDate': minDate,
          '#maxDate': maxDate,
        },
        timeOfDischarge: {
          '#type': 'time',
          '#title': 'Time of Discharge from Health Facility After Delivery',
          '#webform_key': 'timeOfDischarge',
          '#required': true,
          '#isDisabled': false,
        },
      }));
      }
    }
  }

  const handleVisitFormChange = async (value: any, key: string, id?: any, code?: any,) => {
    if(key === 'dateOfDelivery' && value) {
      const minDate = getMinDate(value, '', false);
      const visitDate = getVisitDateThroughVHND(eventExution);
      setVisitFormData((prevState:any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          '#minDate': latestServiceDate ? dayjs(latestServiceDate):visitDate ? visitDate : minDate,
        },
      }))

      if(isDateBefore(visitForm.dateOfVisit.value, value)) {
        setVisitForm((prevState: any) => ({
          ...prevState,
          dateOfVisit: {
            ...prevState.dateOfVisit,
            value: '',
          },
        }));
      }

      if(visitForm.dateOfVisit.value) {
        getPNCAndSetVisitNumber(value, visitForm.dateOfVisit.value,deliveryOutcome);
      } else if (value) {
        getPNCAndSetVisitNumber(value, dayjs(),deliveryOutcome);
      } else {
        setVisitForm((prevState: any) => ({
          ...prevState,
          visitNumber: {
            ...prevState.visitNumber,
            value: '',
          },
        }));
      }
      handleDateOfDischargeValidation(value);
      setVisitForm((prevState: any) => ({
        ...prevState,
        dateOfDischarge: {
          ...prevState.dateOfDischarge,
          value: '',
        },
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          value: '',
        },
      }));
      setVisitFormData((prevState: any) => ({
        ...prevState,
        dateOfDischarge: {
          ...prevState.dateOfDischarge,
          '#isDisabled': false,
        },
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          '#isDisabled': false,
        },
      }));
    } else if(isPNCFirstVisit && key === 'dateOfDelivery' && !value){
      if(childService){
        handleVisitDateValidation(latestServiceDate, latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef,);
      }else{
        setVisitFormData((prevState:any)=>({
          ...prevState,
          dateOfVisit:{
            ...prevState.dateOfVisit,
            '#minDate': dayjs().subtract(config.serviceDateLimit, 'day'),
            '#maxDate': dayjs(),
            '#individualDates': []
          }
        }))
      }
      setVisitFormData((prevState: any) => ({
        ...prevState,
        dateOfDischarge: {
          ...prevState.dateOfDischarge,
          '#isDisabled': true,
        },
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          '#isDisabled': true,
        },
      }));
      setVisitForm((prevState: any) => ({
        ...prevState,
        dateOfDischarge: {
          ...prevState.dateOfDischarge,
          value: '',
        },
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          value: '',
        },
      }));
    }
    if(key === 'dateOfDischarge' && value) {
      const dateOfDelivery = deliveryOutcome?.date_of_delivery ?? visitForm?.dateOfDelivery?.value;
      const minDate = getMinDate(value, '', false);
      const visitDate = getVisitDateThroughVHND(eventExution);
      setVisitFormData((prevState:any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          '#minDate': isDateBefore(latestServiceDate,minDate) ? minDate : latestServiceDate ? dayjs(latestServiceDate):visitDate ? visitDate : minDate,
        },
      }))
      if(isDateBefore(visitForm.dateOfVisit.value, value)) {
        setVisitForm((prevState: any) => ({
          ...prevState,
          dateOfVisit: {
            ...prevState.dateOfVisit,
            value: '',
          },
        }));
      }
      setVisitForm((prevState: any) => ({
        ...prevState,
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          value: '',
        },
      }));
      const isSameAsToday = areDatesSame(dayjs(), value, 'days');
      const isSameAsDelivery = areDatesSame(value, dateOfDelivery, 'days');
      const deliveryTime = isSameAsDelivery && dateOfDelivery ? dayjs(dateOfDelivery) : undefined;
      setVisitFormData((prevState: any) => ({
        ...prevState,
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          '#minTime': deliveryTime ?? '',
          '#maxTime': isSameAsToday ? dayjs() : '',
        },
      }));
    }
    if(key === 'dateOfDischarge' && !value) {
      if(childService && latestServiceDate && latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef){
        handleVisitDateValidation(latestServiceDate, latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef);
      }else{
        setVisitFormData((prevState:any)=>({
          ...prevState,
          dateOfVisit:{
            ...prevState.dateOfVisit,
            '#minDate': visitForm?.dateOfDelivery?.value?visitForm?.dateOfDelivery?.value: dayjs().subtract(29, 'day'),
            '#maxDate': dayjs(),
            '#individualDates': []
          }
        }))}
      setVisitFormData((prevState: any) => ({
        ...prevState,
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          '#minTime': '',
          '#maxTime': '',
        },
      }));
      setVisitForm((prevState: any) => ({
        ...prevState,
        timeOfDischarge: {
          ...prevState.timeOfDischarge,
          value: '',
        },
      }));
    }
    if (key === 'dateOfVisit' && isPNCFirstVisit) {
      if (value) {
        const ninetyDaysAgo = subtractDaysFromDate(dayjs(), 90, 'day');
        const fortyFourDaysBeforeVisit = dayjs(value).subtract(44, 'day');
        const deliveryMinDate = fortyFourDaysBeforeVisit.isAfter(ninetyDaysAgo) ? fortyFourDaysBeforeVisit : ninetyDaysAgo;
        setVisitFormData((prevState: any) => ({
          ...prevState,
          dateOfDelivery: {
            ...prevState.dateOfDelivery,
            '#minDate': deliveryMinDate,
            '#maxDate': dayjs(value),
          },
        }));
        if (visitForm.dateOfDelivery.value && (
          isDateBefore(value, visitForm.dateOfDelivery.value) ||
          isDateBefore(visitForm.dateOfDelivery.value, deliveryMinDate)
        )) {
          setVisitForm((prevState: any) => ({
            ...prevState,
            dateOfDelivery: {
              ...prevState.dateOfDelivery,
              value: '',
            },
          }));
        }
      } else {
        setVisitFormData((prevState: any) => ({
          ...prevState,
          dateOfDelivery: {
            ...prevState.dateOfDelivery,
            '#minDate': subtractDaysFromDate(dayjs(), 90, 'day'),
            '#maxDate': new Date(),
          },
        }));
      }
      if (visitForm.dateOfDelivery.value) {
        if (value) {
          getPNCAndSetVisitNumber(visitForm.dateOfDelivery.value, value,deliveryOutcome);
        } else {
          getPNCAndSetVisitNumber(visitForm.dateOfDelivery.value, dayjs(),deliveryOutcome);
        }
      } else if (value && pregHistoryDetails?.pregnancy_closure_date) {
        getPNCAndSetVisitNumber(pregHistoryDetails?.pregnancy_closure_date, value);
      }
    }
    else if(key === 'dateOfVisit') {
      if (value) {
        getPNCAndSetVisitNumber(currDeliveryDate, value,deliveryOutcome);
      } else {
        getPNCAndSetVisitNumber(currDeliveryDate, dayjs(),deliveryOutcome);
      }
    }
    setVisitForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code,
      },
    }));
  };

  const isDateBefore = (date1:any, date2:any) => {
    if(!date1 || !date2) {
      return false
    }

    return dayjs(date1).isBefore(date2, 'day');
  }

  const handleDeliveryVisitDateValidation = (value: any) => {
    if (isDateValid(value)) {
      const today = dayjs();
      const inputDate = dayjs(value);

      for (let i = 0; i < 15; i++) {
        const dateToCompare = today.subtract(i, 'day');
        if (areDatesSame(inputDate, dateToCompare, 'day')) {
          return dateToCompare.toDate();
        }
      }
      return today.subtract(15, 'day').toDate();
    } else {
      return dayjs().subtract(15, 'day').toDate();
    }
  };

  const isDateValid = (date:any) => {
    if(!date && !dayjs(date).isValid()) {
      return false;
    }

    return dayjs().diff(dayjs(date), 'day') < 3;
  }

  const handleBack = () => {
    if(!childService){
      dispatch(updatePNC('isPNCFirstVisit', false));
      dispatch(updatePNC('currPregnancyId', ''));
      navigateWithMenuItem(`/beneficiaries/view/${benfDetails[0]?.benef_id}`,'Pregnancy Services')
    }else{
      navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
      dispatch(updateAncService('currentFacilityDetails', {}));
    }
  };

  const handleSubmit = async () => {
    let checkError = false;

    if (!facilityFormState.facilityType.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          isError: true,
          message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.FACILITY_TYPE),
        },
      }));
      checkError = true;
    }
    if (!facilityFormState.facilityName.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          isError: true,
          message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.FACILITY_NAME),
        },
      }));
      checkError = true;
    }
    if (!facilityFormState.hprName.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        hprName: {
          ...prevState.hprName,
          isError: true,
          message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.HPR_NAME),
        },
      }));
      checkError = true;
    }
    if (isPNCFirstVisit && vistFormData?.dateOfDelivery?.["#required"] && !visitForm.dateOfDelivery.value) {
        setVisitForm((prevState: any) => ({
            ...prevState,
            dateOfDelivery: {
            ...prevState.dateOfDelivery,
            isError: true,
            message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.DATE_OF_DELIVERY),
        },
        }));
        checkError = true;
    }
    if (vistFormData?.dateOfDischarge?.["#required"] && !visitForm.dateOfDischarge.value) {
      setVisitForm((prevState: any) => ({
          ...prevState,
          dateOfDischarge: {
          ...prevState.dateOfDischarge,
          isError: true,
          message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.DATE_OF_DISCHARGE),
      },
      }));
      checkError = true;
  }
  if (vistFormData?.timeOfDischarge?.["#required"] && !visitForm.timeOfDischarge.value) {
    setVisitForm((prevState: any) => ({
        ...prevState,
        timeOfDischarge: {
        ...prevState.timeOfDischarge,
        isError: true,
        message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.TIME_OF_DISCHARGE),
    },
    }));
    checkError = true;
    }
    if (visitForm.dateOfVisit.isError && visitForm.dateOfVisit.message) {
      checkError = true;
    } else if (!visitForm.dateOfVisit.value) {
      setVisitForm((prevState: any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          isError: true,
          message: PNC_ERROR_MESSAGES.FIELD_REQUIRED(PNC_FIELDS_NAME.DATE_OF_VISIT),
        },
      }));
      checkError = true;
    }

    if (!checkError) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    } else {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
      setSelectedPerc(0);
      return;
    }

    const isChildSameDayService: boolean =
      childService && !!latestChildAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef
        ? dayjs(visitForm.dateOfVisit.value).isSame(
            dayjs(latestChildAvailedServiceDateRes.data[0].get_latest_service_availed_date_for_benef), 'day')
        : false;

        const isPNCMotherSameDayService: boolean = !childService && !!latestServiceDate
      ? dayjs(visitForm.dateOfVisit.value).isSame(dayjs(latestServiceDate), 'day')
      : false;

    const currFacilityDetails = {
      facilityId: facilityFormState.facilityName.id,
      healthProviderId: facilityFormState.hprName.id,
      mobilizerId: isMobilizerHavingValue(facilityFormState.ashaName.id),
      visitDate: visitForm.dateOfVisit.value,
      deliveryDate: isDeliveryCaptured ? isDeliveryCaptured : visitForm.dateOfDelivery.value,
      facilityName: facilityFormState.facilityName.value,
      facilityType: facilityFormState.facilityType.value,
      hprName: facilityFormState.hprName.value,
      ashaName: isMobilizerHavingValue(facilityFormState.ashaName.value),
      currRoute: serviceDetails?.currRoute,
      visitNumber:visitForm?.visitNumber?.value ?? '',
      dateOfDischarge: visitForm?.dateOfDischarge?.value ?? '',
      timeOfDischarge: visitForm?.timeOfDischarge?.value ?? '',
      isChildSameDayService,
      isPNCMotherSameDayService
    };
    dispatch(updateAncService('currentFacilityDetails',currFacilityDetails,));

    navigate(serviceDetails?.currRoute);
  };

  const contents = [
    <div key="Service">{
      isLoading?<Spinner/>:
    <div key="Service">
      <form className="pnc_details">
        <CommonFormFields
          formData={facilityData}
          formState={facilityFormState}
          handleFormChange={handleFacilityFormChange}
        />
      </form>
      <form className="pnc_service_visit_details">
          <CommonFormFields
            formData={vistFormData}
            formState={visitForm}
            handleFormChange={handleVisitFormChange}
          />
      </form>
    </div>}
    </div>,
  ];

  const isFormChanged = (ancServiceFormState: any) => {
    for (const key in facilityObj) {
      if (ancServiceFormState[key].value !== facilityObj[key].value) {
        return true;
      }
    }
    return false;
  };

  const handleCancel = () => {
    setModalTitle(PNC_COMMON_CONSTANTS.CLOSE_MODAL_TITLE);
    setAlertModalOpen(true);
  };

  const closeAlertModal = (value: boolean) => {
    if (value) {
      setAlertModalOpen(false);
      handleBack();
    } else {
      setAlertModalOpen(false);
    }
  };

  return (
    <div>
      <>
        <ServiceOutline
          breadcrumbItemName={breadcrumbItemName}
          childService= {childService}
          onHandleBackArrowButton={handleBack}
          navItemsModal={navItemsModal}
          activeIndex={activeIndex}
          handleNavClick={() => {}}
          formCompleted={[false]}
          headerName={PNC_COMMON_CONSTANTS.FACILITY_DETAILS}
          progressBarPerc={selectPerc}
          contents={contents}
          finishHandler={handleSubmit}
          handleCancel={handleCancel}
          title={PNC_COMMON_CONSTANTS.ADD_DETAILS}
        />
        <AlertPopup
          showModal={alertModalOpen}
          closeModal={closeAlertModal}
          title={modalTitle}
        />
      </>
    </div>
  );
};

export default PNCFacilityDetails;
